import React, { useState, useEffect } from 'react';
import './ContenedorMaterias.css';
import BotonMateria from './BotonMateria';
import imagen_materia from '../Assets/materia.jpg';
import axios from 'axios';
import { getClases } from '../Pages/constants';
import { useData } from '../Pages/DataContext';

const ContenedorMaterias = ({ redireccionB }) => {
  const [materias, setMaterias] = useState([]);
  const { setClaseData } = useData();

  // Paginación
  const [paginaActual, setPaginaActual] = useState(1);
  const materiasPorPagina = 9;

  // Buscador
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchMaterias = async () => {
      try {
        const { data } = await axios.get(getClases);
        setMaterias(data);
      } catch (error) {
        console.error('Error al obtener las materias:', error);
      }
    };
    fetchMaterias();
  }, []);

  const editarClase = (val) => {
    setClaseData(val);
    console.log('Valores de clase: ', val);
  };

  // Filtrado por nombre
  const filteredMaterias = materias.filter((m) =>
    (m.nombre_clase || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Total de páginas (puede ser 0 si no hay resultados)
  const totalPaginas = Math.ceil(filteredMaterias.length / materiasPorPagina);

  // Asegurar que paginaActual siempre esté dentro [1, totalPaginas] cuando cambie el filtro
  useEffect(() => {
    setPaginaActual(1);
  }, [searchTerm]);

  useEffect(() => {
    if (totalPaginas > 0 && paginaActual > totalPaginas) {
      setPaginaActual(totalPaginas);
    }
  }, [totalPaginas, paginaActual]);

  // Materias de la página actual
  const paginaSegura = totalPaginas === 0 ? 1 : paginaActual;
  const indiceUltima = paginaSegura * materiasPorPagina;
  const indicePrimera = indiceUltima - materiasPorPagina;
  const materiasActuales = filteredMaterias.slice(indicePrimera, indiceUltima);

  return (
    <div className="contenedor-materias">
      {/* Buscador */}
      <div className="buscador center">
        <input
          type="text"
          placeholder="Buscar materia"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Lista o mensaje vacío */}
      {filteredMaterias.length === 0 ? (
        <p className="sin-materias">No hay materias.</p>
      ) : (
        materiasActuales.map((materia, index) => (
          <BotonMateria
            key={index}
            imagen={imagen_materia}
            nombre={materia.nombre_clase}
            descripcion={materia.descripcion}
            salon={materia.matricula_clase}
            profesor={materia.matricula_maestro}
            redireccion={redireccionB}
            onEditarClase={() => editarClase(materia)}
          />
        ))
      )}

      {/* Paginación: se oculta si no hace falta */}
      {totalPaginas > 1 && (
        <div className="paginacion">
          <button
            onClick={() => setPaginaActual(1)}
            disabled={paginaActual === 1}
          >
            Primera
          </button>

          <button
            onClick={() => setPaginaActual((p) => Math.max(1, p - 1))}
            disabled={paginaActual === 1}
          >
            Anterior
          </button>

          <span className="pagina-info">
            Página {paginaActual} de {totalPaginas}
          </span>

          <button
            onClick={() =>
              setPaginaActual((p) => Math.min(totalPaginas, p + 1))
            }
            disabled={paginaActual === totalPaginas}
          >
            Siguiente
          </button>

          <button
            onClick={() => setPaginaActual(totalPaginas)}
            disabled={paginaActual === totalPaginas}
          >
            Última
          </button>
        </div>
      )}
    </div>
  );
};

export default ContenedorMaterias;
